module.exports = __webpack_public_path__ + "media/images/humidity-muted-05d3bb13279120096b4fac7749f63b8e.svg";